<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width"
        :height="height" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512"
        xml:space="preserve" class="">
        <g>
            <path
                d="M331.28 468.694 272 409.334v-41.36c0-8.84-7.16-16-16-16s-16 7.16-16 16v41.36l-59.28 59.28c-6.248 6.248-6.248 16.392 0 22.64s16.392 6.248 22.64 0l36.64-36.64v25.36c0 8.84 7.16 16 16 16s16-7.16 16-16v-25.36l36.72 36.72c6.56 5.92 16.68 5.408 22.6-1.152 5.512-6.112 5.496-15.4-.04-21.488z"
                style="--darkreader-inline-fill: var(--darkreader-background-576d7e, #465765);" fill="#576d7e"
                data-original="#576d7e" data-darkreader-inline-fill=""></path>
            <path d="M496 63.974v272c0 17.672-14.328 32-32 32H48c-17.672 0-32-14.328-32-32v-272h480z"
                style="--darkreader-inline-fill: var(--darkreader-background-e2e7f0, #242729);" fill="#e2e7f0"
                data-original="#e2e7f0" data-darkreader-inline-fill="" class=""></path>
            <path
                d="M16 15.974h480c8.84 0 16 7.16 16 16v16c0 8.84-7.16 16-16 16H16c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16z"
                style="--darkreader-inline-fill: var(--darkreader-background-c97629, #a15e21);" fill="#c97629"
                data-original="#c97629" data-darkreader-inline-fill="" class=""></path>
            <path d="M168 135.974c-44.184 0-80 35.816-80 80s35.816 80 80 80 80-35.816 80-80h-80v-80z"
                style="--darkreader-inline-fill: var(--darkreader-background-3cb54a, #30913b);" fill="#3cb54a"
                data-original="#3cb54a" data-darkreader-inline-fill=""></path>
            <path d="M184 119.974v80h80c0-44.184-35.816-80-80-80z"
                style="--darkreader-inline-fill: var(--darkreader-background-327d3e, #286432);" fill="#327d3e"
                data-original="#3689c9" data-darkreader-inline-fill="" class="" opacity="1"></path>
            <circle cx="348" cy="147.974" r="12"
                style="--darkreader-inline-fill: var(--darkreader-text-327d3e, #83cd8f);" fill="#327d3e"
                data-original="#3689c9" data-darkreader-inline-fill="" class="" opacity="1"></circle>
            <circle cx="348" cy="235.974" r="12"
                style="--darkreader-inline-fill: var(--darkreader-text-3cb54a, #5ac867);" fill="#3cb54a"
                data-original="#3cb54a" data-darkreader-inline-fill=""></circle>
            <path
                d="M408 183.974h-64c-4.416 0-8-3.584-8-8s3.584-8 8-8h64c4.416 0 8 3.584 8 8s-3.584 8-8 8zM408 271.974h-64c-4.416 0-8-3.584-8-8s3.584-8 8-8h64c4.416 0 8 3.584 8 8s-3.584 8-8 8zM376 295.974h-32c-4.416 0-8-3.584-8-8s3.584-8 8-8h32c4.416 0 8 3.584 8 8s-3.584 8-8 8z"
                style="--darkreader-inline-fill: var(--darkreader-background-748b9e, #4f6271);" fill="#748b9e"
                data-original="#748b9e" data-darkreader-inline-fill="" class=""></path>
            <path
                d="M16 63.974c0 8.84 7.16 16 16 16h432c8.84 0 16 7.16 16 16v240c0 8.84-7.16 16-16 16H64c-8.84 0-16 7.16-16 16h416c17.672 0 32-14.328 32-32v-272H16z"
                style="--darkreader-inline-fill: var(--darkreader-background-c9d5e3, #2f3335);" fill="#c9d5e3"
                data-original="#c9d5e3" data-darkreader-inline-fill="" class=""></path>
            <path d="M32 47.974h448c8.84 0 16 7.16 16 16H16c0-8.84 7.16-16 16-16z"
                style="--darkreader-inline-fill: var(--darkreader-background-b06328, #8d4f20);" fill="#b06328"
                data-original="#b06328" data-darkreader-inline-fill="" class=""></path>
            <path
                d="M279.04 439.014c-4.48-4.48-7.04-26.64-7.04-32.96v-38.08h-32v16c8.84 0 16 7.16 16 16v96c8.84 0 16-7.16 16-16v-25.36l36.72 36.72c6.248 6.248 16.376 6.256 22.624.016l.016-.016-52.32-52.32zM192 495.974a15.967 15.967 0 0 0 11.28-4.72l36.72-36.64v-22.64l-59.28 59.28c2.984 3 7.04 4.696 11.28 4.72z"
                style="--darkreader-inline-fill: var(--darkreader-background-3f556b, #324456);" fill="#3f556b"
                data-original="#3f556b" data-darkreader-inline-fill=""></path>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'Presentation',
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    }
}
</script>